import { component } from 'picoapp';
import Marquee3k from 'marquee3000';

export default component((node, ctx) => {
  document.body.classList.add('has-announcement-bar');
});
